<template>
  <el-steps :active="active" finish-status="success" align-center>
    <el-step title="活动基础设置"></el-step>
    <el-step title="邀请人设置"></el-step>
    <el-step title="被邀人设置"></el-step>
    <el-step title="设置确认"></el-step>
    <!-- <el-step title="完成"></el-step> -->
  </el-steps>
</template>
<script>
export default {
  props: {
    active:{
      type: Number,
      default: 0
    }
  },
  watch:{
    active: {
      handler(newVal,oldVal) {
        console.log('watch value',newVal)
      },
      immediate: true
    }
  },
  data(){
    return{}
  },
}
</script>